export enum EntityType {
  SOLICITATION = 'SOLICITATION',
  DOCUMENT = 'DOCUMENT',
  PAYMENT = 'PAYMENT'
}
